/**
 * Client-side session snapshot. Populated once per page load (in index.ts) from
 * the `/json/user/info` response, then read by pages/widgets to gate UI by
 * right — e.g. hiding an export tab the user can't use.
 *
 * This is UX only and NEVER a security boundary: every REST route is still
 * enforced server-side (checkMWPAUserIsLoginACL + aclRight → 403), so a direct
 * URL hit is rejected regardless of what the UI shows. The `rights` list here is
 * the effective, parent-expanded set the backend already computed
 * (ACLRbac.expandRights), so a plain `has()` check mirrors the server.
 */
export class Session {
    /**
     * Store the current user from a /json/user/info response. Admins resolve to
     * the `root` role on the backend (all rights), mirrored by the isAdmin flag.
     * @param {UserInfoData} [user]
     */
    static setUser(user) {
        var _a, _b;
        Session._isAdmin = (_a = user === null || user === void 0 ? void 0 : user.isAdmin) !== null && _a !== void 0 ? _a : false;
        Session._rights = new Set((_b = user === null || user === void 0 ? void 0 : user.rights) !== null && _b !== void 0 ? _b : []);
    }
    /**
     * True when the user may use the given right. No right (undefined) is always
     * allowed; admins pass everything.
     * @param {string} [right]
     * @return {boolean}
     */
    static hasRight(right) {
        return right === undefined || Session._isAdmin || Session._rights.has(right);
    }
}
Session._isAdmin = false;
Session._rights = new Set();
